import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../inventory-category-list/model/category-list.constants";
import { editEntry } from "./category-edit.component.service";
import InventoryCategoryEditTemplateComponent from "./category-edit-template.component";
import { getInventoryCategoryInputs } from "../model/inventory-category.modal";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  CATEGORY_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const InventoryCategoryEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let CategoryPayload = {};
    for (let i = 0; i < values.length; i++) {
      CategoryPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const CategoryResponse = await editEntry(
      location?.state?.row?.id,
      CategoryPayload
    ); 

    // INFO : check api response and show relevant alert message
    if (CategoryResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: CategoryResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getInventoryCategoryInputs({
      name: location?.state?.row?.name || "",
      image: location?.state?.row?.image || "",
      unique_id: location?.state?.row?.unique_id || "",
      status: location?.state?.row?.status || "", 
      repeater: location?.state?.row?.repeater || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <InventoryCategoryEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default InventoryCategoryEditComponent;
